import { Likes } from "../entities/userMatch";
import { LikesParams } from "../entities/getLikesParams";
import { MatchRepository } from "../repositories/MatchRepository";

export class GetMyMatches {
	constructor(private repository: MatchRepository) {}
	execute(params: GetMyMatchesParams): Promise<Likes[]> {
		return this.repository.getMyMatches(params.params);
	}
}

export class GetMyMatchesParams {
	constructor(public params: LikesParams) {}
}
